import React from 'react';
import ModalV1 from '../modal-v1/index';
import { DiscardSalesContent } from './discard-sales-content';

type DiscardSaleModalProps = {
	show: boolean;
	onClose: () => void;
};

export const DiscardSaleModal = ({ show, onClose }: DiscardSaleModalProps) => {
	return (
		<ModalV1
			classes={{ content: 'z-[500]' }}
			show={show}
			onClose={onClose}
			headerAction={<div className="text-base font-semibold text-gray-900">Discard Sale</div>}
		>
			<DiscardSalesContent onClose={onClose} />
		</ModalV1>
	);
};

export default DiscardSaleModal;
